// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('card_title_on_card_front');

// eslint-disable-next-line @trello/no-module-logic
export const CardTitleOnCardFrontTemplate = t.renderable(function ({
  idShort,
  name,
  separatorClassName,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  // guide/hacks/id-short
  if (idShort) {
    t.span('.card-short-id.hide', () => t.format('idshort', { idShort }));
  }
  if (separatorClassName) {
    return t.div(`.${separatorClassName}`);
  } else {
    return t.text(name);
  }
});
